import { Form, InputRef } from 'antd';
import React, { useRef } from 'react';
import styled from 'styled-components';
import InputRadioType from './InputRadioType';
import PercentDecimalInputPrecision from 'components/PercentDecimalInputPrecision';
import CurrencyInputPrecision from 'components/CurrencyInputPrecision';
import { DISCOUNT_VALUE_TYPE } from 'features/settingService/services/constants';

const InputDefaultIncentive = () => {
  const inputPerRef = useRef<InputRef>(null);
  const inputDolRef = useRef<InputRef>(null);
  const handleChangeType = (e: DISCOUNT_VALUE_TYPE) => {
    setTimeout(() => {
      if (e === DISCOUNT_VALUE_TYPE.DOLLAR) {
        inputDolRef.current?.focus();
      } else {
        inputPerRef.current?.focus();
      }
    }, 100);
  };

  return (
    <Container>
      <Form.Item name='discountType' initialValue={DISCOUNT_VALUE_TYPE.PERCENT}>
        <InputRadioType onChange={handleChangeType} />
      </Form.Item>

      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const discountType = getFieldValue('discountType');
          return (
            <LabelBox>
              <div className='label'>Discount</div>
              <Form.Item noStyle name='discountValue'>
                {discountType === DISCOUNT_VALUE_TYPE.PERCENT ? (
                  <PercentDecimalInputPrecision
                    maxValue={100}
                    inputRef={inputPerRef}
                    height={'3.5rem'}
                  />
                ) : (
                  <CurrencyInputPrecision
                    className='CurrencyInputPrecision'
                    inputRef={inputDolRef}
                    height={'3.5rem'}
                  />
                )}
              </Form.Item>
            </LabelBox>
          );
        }}
      </Form.Item>
    </Container>
  );
};

export default InputDefaultIncentive;

const Container = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
`;

const LabelBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  .label {
    color: #1d2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
